<template>
    <div class="mapBox">
        <div class="map" id="container" ref="container"></div>
        <div class="fixedMapMenu">
            <div class="menuList">
                <div>当前选择:{{ echartsMapTitle }}</div>
            </div>
            <div class="menuList" @click="resetMap">
                <div class="iconfont icon-shuaxin1"></div>
                <div>重置地图</div>
            </div>
        </div>

        <devicedeatil v-if="deviceDeatilShow" :deviceData="checkDeviceData" @close="deviceDeatilShow = false"> </devicedeatil>
        <msLoading ref="loading"></msLoading>
    </div>
</template>

<script>
import devicedeatil from '@/components/common/maxWeb/devicedeatil.vue';
import axios from 'axios';
import msLoading from '@/components/common/msLoading.vue';
export default {
    components: {
        devicedeatil,
        msLoading
    },
    data() {
        return {
            // 当前的echartsDom对象
            ecahrtsDom: null,
            // 当前echarts所在层级
            echartsMapTitle: '中国',
            // 下钻地图数据
            moreMapArr: [],
            // 下钻地图市级别统计
            cityArrOutPut: [],
            // 下钻地图区级别统计
            countyArrOutPuth: [],
            // 设备详情弹窗是否显示
            deviceDeatilShow: false,
            checkDeviceData: null
        };
    },
    created() {},
    mounted() {
        this.$refs.loading.show();
        this.deviceComput();
    },

    methods: {
        // 还原echarts地图
        resetMap() {
            this.$refs.loading.show();
            this.ecahrtsDom.dispose();
            this.deviceComput();
        },
        // echats中国地图初始化
        async echartsMap(data) {
            if (this.ecahrtsDom !== null) {
                this.ecahrtsDom.dispose();
            }

            this.echartsMapTitle = '中国';
            var myChart = this.$echarts.init(this.$refs.container);
            this.ecahrtsDom = myChart;
            var option;
            this.$echarts.registerMap('china', require('@/utils/echartsMap/chinaChange.json'));

            myChart.setOption(
                (option = {
                    grid: {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        containLabel: true,
                        show: false
                    },
                    xAxis: {},
                    yAxis: {
                        scale: true,
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        backgroundColor: '#2a2a2a',
                        textStyle: {
                            color: '#ffffff',
                            fontWeight: 'bold'
                        },
                        formatter: (e) => {
                            return `区域:${e.name}<br/>数量:${e.value ? e.value : 0}台`;
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: 100,
                        text: ['High', 'Low'],
                        realtime: false,
                        calculable: true,
                        show: false,
                        inRange: {
                            color: ['#00ccff', '#0099ff', '#0066ff']
                        }
                    },

                    series: [
                        {
                            zoom: 1.25,
                            name: 'china',
                            type: 'map',
                            map: 'china',
                            label: {
                                show: false
                            },
                            colorBy: 'series',
                            itemStyle: {
                                areaColor: '#00ffff',
                                borderColor: '#000000'
                            },
                            select: {
                                disabled: true //不可以被选中
                            },
                            emphasis: {
                                label: {
                                    show: false
                                }
                            },
                            data: data
                        }
                    ]
                })
            );

            this.$refs.loading.hide();
            // 监听地图点击事件 (这里监听到了全局的echarts事件 即使当前dom销毁 依然监听)
            myChart.on('click', (e) => {
                // 下钻省级地图
                if (e.seriesName == 'china' && e.name) {
                    this.echartsMapChange(e.name, 'china', this.cityArrOutPut);
                }
                // 下钻市级地图
                if (e.seriesName == 'province' && e.name) {
                    this.echartsMapChange(e.name, 'province', this.countyArrOutPuth);
                }

                // 下钻区级地图
                if (e.seriesName == 'city' && e.name) {
                    this.echartsMapChange(e.name, 'city', this.countyArrOutPuth);
                }

                // 点击了marker标记点
                if (e.componentType == 'markPoint') {
                    console.log(e.name, e.value);
                    // 弹出设备详情卡片
                    this.checkDeviceData = e.value;
                    this.$nextTick(() => {
                        this.deviceDeatilShow = true;
                    });
                }
            });
        },

        // 设备数据处理
        async deviceComput() {
            // 增加省市区等对象
            let arr = [];
            for (let index = 0; index < this.$store.state.deviceNowData.length; index++) {
                let item = this.$store.state.deviceNowData[index];
                // 如果不存在经纬度
                if (item.latitude == null || item.longitude == null) {
                    return {};
                }
                // const result = await this.myGeocoder(item.latitude * 1, item.longitude * 1);
                // console.log('----------------------------------------');
                // console.log(result);
                // item.province = result.province;
                // item.city = result.city;
                // item.county = result.county;
                // item.address = result.address;
                arr.push(item);

                if (index == this.$store.state.deviceNowData.length - 1) {
                    // 全国地图处理开始--------
                    let chinaArr = arr.map((item) => {
                        return item.province;
                    });

                    const chinaArrResult = {};

                    chinaArr.forEach((item) => {
                        // 去除省字
                        let name = item.replace(/省/g, '');
                        name = name.replace(/市/g, '');
                        if (chinaArrResult[name]) {
                            chinaArrResult[name]++;
                        } else {
                            chinaArrResult[name] = 1;
                        }
                    });

                    const chinaArrOutput = Object.keys(chinaArrResult).map((key) => {
                        return {
                            name: key,
                            value: chinaArrResult[key]
                        };
                    });

                    this.echartsMap(chinaArrOutput);

                    // 全国地图处理结束--------

                    // 下钻地图数据处理开始------------
                    this.moreMapArr = arr.map((item) => {
                        let obj = {
                            name: item.anotherName ? item.anotherName : item.deviceName,
                            coord: [item.latitude * 1, item.longitude * 1],
                            value: item
                        };
                        return obj;
                    });

                    // 统计市级别的数据
                    let cityArr = arr.map((item) => {
                        return item.city;
                    });

                    const cityArrResult = {};
                    cityArr.forEach((item) => {
                        // 去除省字
                        if (cityArrResult[item]) {
                            cityArrResult[item]++;
                        } else {
                            cityArrResult[item] = 1;
                        }
                    });

                    this.cityArrOutPut = Object.keys(cityArrResult).map((key) => {
                        return {
                            name: key,
                            value: [cityArrResult[key] * 1]
                        };
                    });

                    // 统计区级别的数据
                    let countyArr = arr.map((item) => {
                        return item.county;
                    });

                    console.log(countyArr);

                    const countyArrResult = {};
                    countyArr.forEach((item) => {
                        // 去除省字
                        if (countyArrResult[item]) {
                            countyArrResult[item]++;
                        } else {
                            countyArrResult[item] = 1;
                        }
                    });

                    this.countyArrOutPuth = Object.keys(countyArrResult).map((key) => {
                        return {
                            name: key,
                            value: [countyArrResult[key] * 1]
                        };
                    });

                    console.log(this.cityArrOutPut);
                    console.log(this.countyArrOutPuth);

                    // 下钻地图数据处理结束------------
                }
            }
        },

        // 天地图地图逆地址解析
        // async myGeocoder(latitude, longitude) {
        //     return new Promise(async (resolve, reject) => {
        //         const result = await axios.get(
        //             `https://api.tianditu.gov.cn/geocoder?postStr={'lon':${latitude},'lat':${longitude},'ver':1}&type=geocode&tk=1bc2a288dc2d3d9b70e69dc1d9ed2a6e`
        //         );
        //         resolve(result.data.result.addressComponent);
        //     });

        //     // const result = await axios.get(
        //     //     `https://api.tianditu.gov.cn/geocoder?postStr={'lon':${latitude},'lat':${longitude},'ver':1}&type=geocode&tk=1bc2a288dc2d3d9b70e69dc1d9ed2a6e`
        //     // );
        //     // return result.data.result.addressComponent;
        // },

        // 地图下钻
        echartsMapChange(e, name, data) {
            console.log(this.echartsMapTitle);
            // 销毁当前echarts
            this.ecahrtsDom.clear();
            // 添加当前选择的层级
            this.echartsMapTitle = this.echartsMapTitle + '-' + e;
            let urlName = null;
            let files = null;
            // 判断目录名
            switch (name) {
                case 'china':
                    urlName = 'province';
                    files = require.context(`@/utils/echartsMap/province/`, false, /.json$/).keys();
                    break;
                case 'province':
                    urlName = 'city';
                    files = require.context(`@/utils/echartsMap/city/`, false, /.json$/).keys();
                    break;
                case 'city':
                    urlName = 'county';
                    files = require.context(`@/utils/echartsMap/county/`, false, /.json$/).keys();
                    break;
                default:
                    break;
            }
            let url = null;
            files.forEach((item, index) => {
                if (item.indexOf(e) !== -1) {
                    url = item;
                }
            });

            var myChart = this.$echarts.init(this.$refs.container);
            this.ecahrtsDom = myChart;
            var option;
            this.$echarts.registerMap(urlName, require(`@/utils/echartsMap/${urlName}/${url.split('./')[1]}`));
            myChart.setOption(
                (option = {
                    grid: {
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'item',
                        backgroundColor: '#2a2a2a',
                        textStyle: {
                            color: '#ffffff',
                            fontWeight: 'bold'
                        },
                        formatter: (e) => {
                            return `区域:${e.name}<br/>数量:${e.value ? e.value : 0}台`;
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: 1000,
                        text: ['High', 'Low'],
                        realtime: false,
                        calculable: true,
                        show: false,
                        inRange: {
                            color: ['#00ccff', '#0099ff', '#0066ff']
                        }
                    },
                    series: [
                        {
                            zoom: 1.25,
                            name: urlName,
                            type: 'map',
                            map: urlName,
                            label: {
                                show: false
                            },
                            markPoint: {
                                symbol: 'circle',
                                symbolSize: 10,
                                show: true,
                                tooltip: {
                                    formatter: `{b}`
                                },
                                label: {
                                    show: false
                                },
                                data: this.moreMapArr
                            },
                            colorBy: 'series',
                            itemStyle: {
                                areaColor: '#00ffff',
                                borderColor: '#000000'
                            },
                            select: {
                                disabled: true //不可以被选中
                            },
                            emphasis: {
                                label: {
                                    show: false
                                }
                            },
                            data: data
                        }
                    ]
                })
            );
        }
    }
};
</script>

<style lang="less" scoped>
.mapBox {
    height: 100%;
    width: 100%;

    .map {
        height: 100%;
        width: 100%;
    }
    .fixedMapMenu {
        background-color: rgba(0, 0, 0, 0.3);
        top: 0;
        right: 0;
        color: #fff;
        height: 40px;
        box-sizing: border-box;
        padding: 5px;
        position: absolute;
        z-index: 99;
        display: flex;
        font-size: 0.2rem;
        justify-content: space-around;
        .menuList {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 10px;
        }
    }
}
</style>